import omit from 'lodash/fp/omit';
import * as status from '@atlassian/jira-portfolio-3-portfolio/src/common/api/request.tsx';
import {
	SENT,
	type SentAction,
	SUCCESS,
	type SuccessAction,
	ERROR,
	type ErrorAction,
	REMOVE,
	type RemoveAction,
} from './actions.tsx';
import type { Changes } from './types.tsx';

const initialState = {
	status: status.UNSENT,
} as const;

export type Action = SentAction | SuccessAction | ErrorAction | RemoveAction;

export const changes = (state: Changes = initialState, action: Action): Changes => {
	switch (action.type) {
		case SENT:
			return { status: status.LOADING };
		case SUCCESS:
			return { status: status.SUCCESS, data: action.payload };
		case ERROR:
			return { status: status.ERROR, error: action.payload };
		case REMOVE: {
			if (!state.data) return state;

			return {
				...state,
				data: {
					...state.data,
					issues: state.data.issues.filter((issue) => issue.id !== action.payload.issueId) || [],
					metaData: {
						...state.data.metaData,
						issues: omit(action.payload.issueId, state.data.metaData.issues),
					},
				},
			};
		}
		default: {
			const _exhaustiveCheck: never = action;
			return state;
		}
	}
};
